import {
    Dashboard as DashboardIcon,
    PeopleOutline as DirectoryIcon,
    Logout as LogoutIcon,
    BarChart as ReportsIcon,
    Settings as SettingsIcon,
} from "@mui/icons-material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Box } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useUser } from "src/allauth/auth";
import { useAppContext } from "src/context/AppContext";
import ProfileIcon from "src/theme/icons/ProfileIcon";
import { MenuButton } from "src/theme/StyledFields";
import { MenuProps, getDrawerClickHandler, getMenuWrapperSx } from "./PublicPagesMenu";

const CoachMenu: React.FC<MenuProps> = ({ layout = 'drawer' }) => {
    const location = useLocation();
    const user = useUser();
    const { membership, closeDrawer } = useAppContext();
    const isAdmin = membership?.roles?.includes('admin') ?? false;

    const menuItems: Array<{
        path: string;
        icon: React.ElementType;
        label: string;
        priority: boolean;
        matchPrefix?: boolean;
    }> = [
            { path: "/dashboard", icon: DashboardIcon, label: "Dashboard", priority: true },
            // { path: "/notifications", icon: NotificationsIcon, label: "Notifications", priority: true },
            //        { path: "/coach-content", icon: SportsIcon, label: "Coach Content", priority: false },
            { path: "/my-profile", icon: ProfileIcon, label: "My Profile", priority: false }
        ];
    if (isAdmin && layout !== 'header') {
        menuItems.splice(1, 0, { path: "/directory", icon: DirectoryIcon, label: "Directory", priority: false });
        menuItems.splice(2, 0, { path: "/reports", icon: ReportsIcon, label: "Reports", priority: false, matchPrefix: true });
        menuItems.splice(3, 0, { path: "/notifications", icon: NotificationsIcon, label: "Notification History", priority: false });
    }



    if (layout !== 'header') {
        menuItems.push({ path: "/my-profile/settings", icon: SettingsIcon, label: "Settings", priority: false });
    }

    if (layout === 'drawer') {
        menuItems.push({ path: "/account/logout", icon: LogoutIcon, label: "Logout", priority: false });
    }

    const renderItems = () => {
        return menuItems.map(({ path, icon: Icon, label, matchPrefix }) => {
            const active = matchPrefix
                ? location.pathname === path || location.pathname.startsWith(`${path}/`)
                : location.pathname === path;
            return (
                <MenuButton
                    key={path}
                    component={Link}
                    to={path}
                    size={layout === 'drawer' ? 'small' : 'medium'}
                    startIcon={<Icon fontSize="small" />}
                    fullWidth={layout === 'drawer'}
                    color={active ? "primary" : "inherit"}
                    sx={{
                        justifyContent: layout === 'drawer' ? 'flex-start' : 'center',
                    }}
                    onClick={getDrawerClickHandler(layout, closeDrawer)}
                >
                    {label}
                </MenuButton>
            );
        });
    };

    return <Box data-menu-role="coach" data-menu-layout={layout} sx={getMenuWrapperSx(layout)}>
        {renderItems()}
    </Box>;
};

export default CoachMenu;